module.exports = __webpack_public_path__ + "static/5-7aaa78967f3ec42061766e2d5b879746.jpeg";